import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import PageLinkModel from 'models/PageLink';

import Wrapper from './styled/Wrapper';
import FooterLink from './styled/FooterLink';
import TopButton from './styled/TopButton';

export default class SecondaryFooter extends PureComponent {


  static defaultProps = {
  };

  static contextType = ThemeContext;

  onTopButtonClick = () => {
    const { onTopButtonClick } = this.props;

    typeof onTopButtonClick === 'function' &&  onTopButtonClick();
  };

  onNextLinkClick = () => {
    const { nextLink } = this.props;
    // if(appState.analytics)appState.analytics._trackEvent('SecondaryFooter', 'click next link', nextLink.link);

  };

  onPrevLinkClick = () => {
    const { prevLink } = this.props;
    // if(appState.analytics)appState.analytics._trackEvent('SecondaryFooter', 'click prev link', prevLink.link);

  };

  render() {
    const { className, nextLink, prevLink, dark } = this.props;

    return (
      <Wrapper theme={this.context} className={className} dark={dark}>
        <FooterLink isBack {...prevLink} dark={dark} onClick={this.onPrevLinkClick} />
        <FooterLink {...nextLink} dark={dark} onClick={this.onNextLinkClick} />
        <TopButton onClick={this.onTopButtonClick} />
      </Wrapper>
    );
  }
}
